import { PlaceTypeEnumType } from '@wix/ambassador-seating-v1-seating-plan/types';
export const isPlaceOccupied = (place, placesStock) => !(placesStock[place.id] ?? 1);
export const getPlaceElementId = (place) => Number(place.id.split('-')[1]);
export const isPlaceSeatTypeImage = (type) => ![PlaceTypeEnumType.STANDARD, PlaceTypeEnumType.UNKNOWN_PROPERTY].includes(type);
//# sourceMappingURL=place.js.map